var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPpedetection(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1_1323)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.5462 52.5C36.2401 50.4412 37.8768 49.0816 39.04 48.5H33.04V37.5L36.04 36C37.64 25.2 50.04 19.1667 56.04 17.5V15H64.04V17.5C70.04 19.1667 82.44 25.2 84.04 36L87.04 37.5V48.5H81.04C82.2032 49.0816 83.8399 50.4412 84.5338 52.5C85.033 53.9812 85.0442 55.8243 84.04 58C81.64 63.2 78.7067 63.8333 77.54 63.5C76.7398 65.5006 74.9789 68.4619 72.2574 71V78C78.685 79.8333 92.14 84.7 94.54 89.5C96.2488 92.9176 96.8761 98.0588 97.0356 102C97.0371 102.038 97.0386 102.075 97.04 102.112C97.0995 103.66 97.0869 105.016 97.04 106H23.04C22.9931 105.016 22.9805 103.66 23.04 102.112C23.0414 102.075 23.0429 102.038 23.0444 102C23.2039 98.0588 23.8312 92.9176 25.54 89.5C27.94 84.7 41.3951 79.8333 47.8226 78V71C45.1011 68.4619 43.3403 65.5006 42.54 63.5C41.3733 63.8333 38.44 63.2 36.04 58C35.0358 55.8243 35.047 53.9812 35.5462 52.5ZM39.9333 67.3037C37.0936 66.4683 34.3283 63.8365 32.4082 59.6762C31.1605 56.9729 30.9636 54.4217 31.4824 52.1854C30.0471 51.578 29.04 50.1566 29.04 48.5V37.5C29.04 35.9849 29.896 34.5999 31.2511 33.9223L32.518 33.2888C34.0314 27.5244 37.9571 23.1787 41.9753 20.1361C45.3314 17.5948 48.9983 15.7672 52.059 14.608C52.256 12.5828 53.9631 11 56.04 11H64.04C66.1169 11 67.824 12.5828 68.021 14.608C71.0817 15.7672 74.7486 17.5948 78.1047 20.1361C82.1229 23.1787 86.0486 27.5244 87.562 33.2889L88.8289 33.9223C90.184 34.5999 91.04 35.9849 91.04 37.5V48.5C91.04 50.1566 90.0329 51.578 88.5976 52.1854C89.1164 54.4218 88.9195 56.9729 87.6718 59.6762C85.7517 63.8365 82.9865 66.4683 80.1467 67.3037C79.214 68.9978 77.9189 70.8746 76.2574 72.6537V75.0386C79.3318 76.0305 83.0843 77.4023 86.5746 79.0007C88.9184 80.0741 91.2484 81.2969 93.2047 82.6322C95.0509 83.8923 97.0475 85.5708 98.1177 87.7111C99.6355 90.7467 100.365 94.5569 100.728 97.7922C101.099 101.105 101.128 104.243 101.035 106.19C100.934 108.323 99.1752 110 97.04 110H23.04C20.9048 110 19.1461 108.323 19.0445 106.19C18.9518 104.243 18.9813 101.105 19.3524 97.7922C19.7148 94.5569 20.4445 90.7467 21.9623 87.7111C23.0325 85.5708 25.0291 83.8923 26.8753 82.6322C28.8316 81.2969 31.1616 80.0741 33.5055 79.0007C36.9957 77.4023 40.7482 76.0305 43.8226 75.0386V72.6537C42.1611 70.8746 40.866 68.9978 39.9333 67.3037Z",
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60.04 15H56.04V17.5V32H64.04V17.5V15H60.04Z",
    fill: "#00A0F3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36.04 36L33.04 37.5V48.5H39.04H60.04H81.04H87.04V37.5L84.04 36H36.04Z",
    fill: "#00A0F3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M56.04 17.5C50.04 19.1667 37.64 25.2 36.04 36H84.04C82.44 25.2 70.04 19.1667 64.04 17.5V32H56.04V17.5Z",
    fill: "#E0F2FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.04 48.5C37.04 49.5 33.64 52.8 36.04 58C38.44 63.2 41.3734 63.8333 42.54 63.5C43.3403 65.5006 45.1011 68.4619 47.8226 71V78C46.7338 78.3106 45.4433 78.7082 44.0391 79.1778C44.3391 80.1152 44.8487 81.2757 45.5829 82.5C47.935 86.4223 52.5912 91 60.04 91C67.4889 91 72.1451 86.4223 74.4971 82.5C74.508 82.4819 74.5187 82.4639 74.5295 82.4458C75.2463 81.2415 75.7454 80.1014 76.041 79.1778C74.6367 78.7082 73.3463 78.3106 72.2574 78V71C74.9789 68.4619 76.7398 65.5006 77.54 63.5C78.7067 63.8333 81.64 63.2 84.04 58C86.44 52.8 83.04 49.5 81.04 48.5H60.04H39.04ZM60.04 76C56.0408 76 52.0397 74.3333 50.5391 73.5C51.5397 76 54.8408 80 60.04 80C65.2393 80 68.5403 76 69.541 73.5C68.0403 74.3333 64.0393 76 60.04 76Z",
    fill: "#E0F2FF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M50.5391 73.5C52.0397 74.3333 56.0408 76 60.04 76C64.0393 76 68.0403 74.3333 69.541 73.5C68.5403 76 65.2393 80 60.04 80C54.8408 80 51.5397 76 50.5391 73.5Z",
    fill: "#BAE1FF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M25.54 89.5C23.14 94.3 22.8733 102.5 23.04 106H38.0391V96V91V81.398C32.4958 83.6647 26.9927 86.5946 25.54 89.5Z",
    fill: "#00A0F3"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M74.4971 82.5C72.1451 86.4223 67.4889 91 60.04 91C52.5912 91 47.935 86.4223 45.5829 82.5V91V96H74.4971V91V82.5Z",
    fill: "#00A0F3"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M94.54 89.5C93.0873 86.5946 87.5843 83.6647 82.041 81.398V91V96V106H97.04C97.2067 102.5 96.94 94.3 94.54 89.5Z",
    fill: "#00A0F3"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M60.04 106H82.041V96H74.4971H45.5829H38.0391V106H60.04Z",
    fill: "#01497B"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M44.0391 79.1778C42.1714 79.8023 40.1024 80.5542 38.0391 81.398V91H45.5829V82.5C44.8487 81.2757 44.3391 80.1152 44.0391 79.1778Z",
    fill: "#01497B"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M82.041 81.398C79.9776 80.5542 77.9087 79.8023 76.041 79.1778C75.7454 80.1014 75.2463 81.2415 74.5295 82.4458C74.5187 82.4639 74.508 82.4819 74.4971 82.5V91H82.041V81.398Z",
    fill: "#01497B"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M38.0391 96H45.5829V91H38.0391V96Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M74.4971 96H82.041V91H74.4971V96Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M39.04 48.5H33.04V37.5L36.04 36C37.64 25.2 50.04 19.1667 56.04 17.5V15H60.04H64.04V17.5C70.04 19.1667 82.44 25.2 84.04 36L87.04 37.5V48.5H81.04M39.04 48.5C37.04 49.5 33.64 52.8 36.04 58C38.44 63.2 41.3733 63.8333 42.54 63.5C43.3403 65.5006 45.1011 68.4619 47.8226 71V78C41.3951 79.8333 27.94 84.7 25.54 89.5C23.14 94.3 22.8733 102.5 23.04 106H60.04H97.04C97.2067 102.5 96.94 94.3 94.54 89.5C92.14 84.7 78.685 79.8333 72.2574 78V71C74.9789 68.4619 76.7398 65.5006 77.54 63.5C78.7067 63.8333 81.64 63.2 84.04 58C86.44 52.8 83.04 49.5 81.04 48.5M39.04 48.5H81.04",
    stroke: "#01497B",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1_1323",
    x: 17,
    y: 10,
    width: 88.0781,
    height: 105,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0196078 0 0 0 0 0.176471 0 0 0 0 0.254902 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1_1323"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1_1323",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPpedetection);
export default __webpack_public_path__ + "static/media/ppedetection.bfc8350ad35702b45bc9d2539cecbfca.svg";
export { ForwardRef as ReactComponent };